import getMuiTheme from "material-ui/styles/getMuiTheme";
import * as Colors from "./colors";

const customTheme = getMuiTheme({
    datePicker: {
        color: "#54698d",
        textColor: "#fff",
        calendarTextColor: "#16325",
        selectColor: "#5e89c6",
        selectTextColor: "#fff",
        headerColor: "#54698d",
        calendarYearBackgroundColor: "#5e89c6"
    },
    flatButton: {
        primaryTextColor: "#54698d"
    },
    timePicker: {
        headerColor: "#54698d"
    },
    palette: {
        primary1Color: "#5e89c6"
    },
    textField: {
        borderColor: "#e8edf4",
        hintColor: "#c7cdd5",
        focusColor: "#5e89c6",
        floatingLabelColor: "#54698d",
        textColor: "#16325c",
        border: "solid .5px #e8edf4"
    },
    radioButton: {
        // checkedColor:'#62d2a2',
        checkedColor: "#1D7CBF",
        labelColor: "#203454",
        // borderColor:'#62d2a2'
        borderColor: "#1D7CBF"
    },
    palette: {
        primary1Color: Colors.indigoA200,
        primary2Color: Colors.indigoA200
    },
    fontFamily: "IBM Plex Sans', sans-serif"
});

export default customTheme;
